export default "__VITE_ASSET__909cb91a__"